import { render, staticRenderFns } from "./ticketPay.vue?vue&type=template&id=1f1216c0&scoped=true"
import script from "./ticketPay.vue?vue&type=script&lang=js"
export * from "./ticketPay.vue?vue&type=script&lang=js"
import style0 from "./ticketPay.vue?vue&type=style&index=0&id=1f1216c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1216c0",
  null
  
)

export default component.exports